import BadgeAvatar from "plos/src/components/avatars/BadgeAvatar";
import { newsItemLinkStyles, teamNewsItemStyles } from "./teamNewsItem.css";
import { TeamNewsItemProps } from "./types";
import { useTrackingContext } from "../../../contexts/TrackingContext";

const TeamNewsItem = ({ article, team }: TeamNewsItemProps) => {
  const { fireClickTrackEvent } = useTrackingContext();

  const { hotlinkUrl, title } = article;

  const handleClick = () => {
    if (hotlinkUrl) {
      const pathName = location.pathname;
      const pathNameFormatted = pathName.replace(/^\/|-/g, (match) =>
        match === "-" ? " " : "",
      );
      fireClickTrackEvent(
        {
          event_component: "outbound link click",
          event_category: "fantasy league",
          event_type: "click team news link",
          click_url: hotlinkUrl,
        },
        `fantasy ${pathNameFormatted}`,
      );
    }
  };

  return (
    <div className={teamNewsItemStyles}>
      {team && <BadgeAvatar team={team} size="small" />}
      {/* hotlinkUrl should always be set, but being defensive because stranger things happen */}
      {hotlinkUrl ? (
        <a
          // handleClick already tracks this click, so skip the generic outbound listener.
          data-track-click="manual"
          href={hotlinkUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={newsItemLinkStyles}
          onClick={handleClick}
        >
          {title}
        </a>
      ) : (
        <div className={newsItemLinkStyles}>{title}</div>
      )}
    </div>
  );
};

export default TeamNewsItem;
